<template>
    <section id="contact" class="contact container">
        <div class="contact-wrapper">
            <h2 class="contact__title">Contact us</h2>
            <form class="contact-form" @submit.prevent="contactFormSubmit($event)">
                <div class="inline-inputs">
                    <label class="hide" for="fullname">Full name</label>
                    <input class="contact-form__input" placeholder="Full name" id="fullname" type="text" name="fullName" v-model="fullName" required>
        
                    <label class="hide" for="email">Email</label>
                    <input class="contact-form__input" placeholder="Email" id="email" type="email" name="email" v-model="email" required>
                </div>
    
                <label class="hide" for="name">Phone number</label>
                <input class="contact-form__input" placeholder="Phone number" id="phonenumber" type="text" name="phoneNumber" v-model="phone">
    
                <label class="hide" for="address">Ask us anything</label><br>
                <textarea class="contact-form__input" placeholder="Ask us anything" id="address" name="content" v-model="message"></textarea>
    
                <input class="contact-form__submit btn btn--white" type="submit" value="Send">
                <div v-if="sent" class="contact-form__success help is-success">Message success!</div>
            </form>
            <img class="contact__bg" src="@/assets/img/bg-logo.svg">
        </div>
    </section>
</template>

<script>
import {db} from '@/firebase.js'

export default {
    props: ['contactDetails', 'contactFormEmails'],
    data() {
        return {
            fullName: null,
            email: null,
            phone: null,
            message: null,
            sent: false
        }
    },
    methods: {
        contactFormSubmit(e) {
            db.collection('messages').add({
                fullName: this.fullName,
                fromEmail: this.email,
                toEmails: this.contactFormEmails,
                phone: this.phone,
                message: this.message,
                date: new Date()
            }).then(e => {
                this.fullName = null,
                this.email = null,
                this.phone = null,
                this.message = null,
                this.sent = true
            })
        }
    }
}
</script>

<style lang="scss">
@import "@/assets/css/helpers-variables.scss";

.contact {
  background: $lipstick;
  color: white;
  position: relative;
  padding-top: 40px;
  padding-bottom: 40px;
  @media (min-width: $laptop-s) {
    padding-top: 80px;
  padding-bottom: 80px;
  }
}
.contact-wrapper {
    max-width: $phone-l;
    margin: 0 auto;
    @media (min-width: $laptop-s) {
        max-width: $tablet;
    }
}
.contact__title {
  font-size: 2.5em;
  font-weight: 600;
  text-align: center;
  line-height: 1;
  margin-bottom: 80px;
  @media (min-width: $laptop-s) {
      font-size: 4em;
  }
  @media (min-width: $laptop-l) {
      font-size: 4.4em;
  }
}
.contact__bg {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  pointer-events: none;
}

.contact-form__input {
    background: transparent;
    border: none;
    border-bottom: 1px solid white;
    width: 100%;
    font-size: 1.25em;
    color: white;
    line-height: 2;
    margin: 0.5em 0;
    font-weight: 600;
    &::placeholder {
        color: rgba(255,255,255,0.7);
    }
}

.contact-form__submit {
    text-transform: uppercase;
    margin: 0 auto;
    display: block;
    cursor: pointer;
}
.contact-form__success {
    text-align: center;
}
</style>
